import React from "react";
import { object, string } from "prop-types";
import { WithLazy } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import PublishedAt from "../../atoms/PublishedAt";
import Excerpt from "../../atoms/Excerpt";
import Anchor from "../../atoms/Anchor";

import { staticTexts } from "../../utils/Translate";

import "./customStoryCard10.m.css";

const CustomStoryCard10 = ({ story, className = "", lang }) => {
  if (!story) return null;

  const sentTime = story.created_time + " GMT";

  const {
    notification_url: notificationUrl,
    notification_title: notificationTitle,
    notification_message: notificationMessage,
    notification_image: notificationImage,
  } = story;

  const showLink = story.notification_url !== "https://www.prothomalo.com";

  return (
    <div styleName="base" className={className}>
      <div styleName="wrapper" className={`${showLink ? "" : "no-link"}`}>
        <div styleName="story-data">
          <PublishedAt
            date={new Date(sentTime.toLocaleString())}
            className={`notification-storydate ${showLink ? "" : "time-style"}`}
          />
          {showLink ? (
            <Anchor aria-label={notificationTitle} href={notificationUrl}>
              <span>
                <h2 styleName="title-headline">{notificationTitle}</h2>
                <h4 styleName="headline-details">{staticTexts(lang).detailsText}</h4>
              </span>
            </Anchor>
          ) : (
            <h2 className="type-27">{notificationTitle}</h2>
          )}

          {notificationMessage ? <Excerpt excerpt={notificationMessage} url={notificationUrl} /> : null}
        </div>
        {showLink && notificationImage && (
          <WithLazy margin="50px">
            {() => (
              <Anchor aria-label={notificationTitle} href={notificationUrl}>
                <img src={notificationImage} />
              </Anchor>
            )}
          </WithLazy>
        )}
      </div>
    </div>
  );
};

CustomStoryCard10.propTypes = {
  story: object.isRequired,
  className: string,
  lang: string,
};

const mapStateToProps = (state) => ({
  isLoading: get(state, ["pageLoading"], false),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(CustomStoryCard10);
